import React from 'react';
import { useTranslation } from 'react-i18next';

const VideoChatEmptyContent = () => {
  const { t } = useTranslation();

  return (
    <div className={'video-chat-empty-content'}>
      <p className={'video-chat-empty-text'}>{t('chat_end_msg')}</p>
    </div>
  );
};

export default VideoChatEmptyContent;
